import template from './templates/pdp-login';
import { redirectParam } from '@utils/login-redirect';

const parsedTemplate = $.parseHTML(template);

export default class PdpLogin {
    constructor($el, labels = {}) {
        $el.replaceWith(parsedTemplate);

        this.$el = $(parsedTemplate);

        // non-dynamic label regions
        this.$login = this.$el.find('[data-label="login"]');

        // dynamic data regions
        this.$description = this.$el.find('[data-region="description"]');

        this.linkText = labels.Login;
        this.linkUrl = labels.LoginLink;
        this.description = labels.LoginDescription;

        this.init();
    }

    init() {
        this.renderLogin();
        this.renderDescription();
    }

    renderDescription() {
        if(this.description) {
            this.$description.html(this.description);
        } else {
            this.$description.hide();
        }
    }

    renderLogin() {
        this.$login.html(this.linkText);
        this.setLink();
    }

    setLink() {
        if(this.linkUrl) {
            const redirect = window.location.pathname;
            this.$login.attr('href', `${this.linkUrl}?${redirectParam(redirect)}`);
            //let testurl = `${this.linkUrl}?${redirectParam(redirect)}`;
            //console.log(testurl);
        }
    }
}
